import React from 'react';
import { withRouter, matchPath } from 'react-router';
import Truncate from 'react-truncate';
import Link from './Link';
import { lastWithfirstInitialList } from '../utils/format-author';
import { getSlug } from '../utils/url';

const Ellipsis = ({ to, track }) => (
  <span>
    <Link to={to} data-name="expand" track={{ ...track, action: 'ExpandAuthors' }}>
      {' ...see all'}
    </Link>
  </span>
);

const Authors = ({
  doc: { authors = [], link }, match: { url }, track
}) => {
  if (!authors.length) return null;
  const onAuthors = matchPath(url, { path: '/:identifier/authors/' });
  const authorsString = lastWithfirstInitialList(authors);
  const to = `${getSlug(link)}/authors/`;

  return (
    <div className="authors" data-name="authors">
      {onAuthors && (
        <span>{authorsString}</span>
      )}
      {!onAuthors && (
        <Truncate
          lines={1}
          ellipsis={<Ellipsis to={to} track={track} />}
        >
          {authorsString}
        </Truncate>
      )}
    </div>
  );
};

export default withRouter(Authors);



// WEBPACK FOOTER //
// ./src/universal/ui/components/Authors.js